<template>
    <div class="logo__wrap" :class="[position]" v-bind="$attrs">
        <div class="logo__inner">
            <svg
                xmlns="http://www.w3.org/2000/svg" width="92" height="23" viewBox="0 0 92 23"
                fill="none"
            >
                <ellipse
                    cx="6.73661" cy="6.35833" rx="6.73661" ry="6.35833"
                    :fill="gradient ? 'url(#paint0_linear_1691_8)' : fill"
                />
                <ellipse
                    cx="18.4134" cy="6.35833" rx="6.73661" ry="6.35833"
                    :fill="gradient ? 'url(#paint1_linear_1691_8)' : fill"
                />
                <ellipse
                    cx="18.4134" cy="16.5317" rx="6.73661" ry="6.35833"
                    :fill="gradient ? 'url(#paint2_linear_1691_8)' : fill"
                />
                <ellipse
                    cx="6.73661" cy="16.5317" rx="6.73661" ry="6.35833"
                    :fill="gradient ? 'url(#paint3_linear_1691_8)' : fill"
                />
                <path d="M41.8501 7.34227H32.7449V4.86804H45.6439V6.97938L36.2418 18.4268V18.4928H45.7759V21H32.448V18.8887L41.8501 7.40825V7.34227ZM51.4067 21H48.8335V8.72783H51.4067V21ZM48.5036 5.09897C48.5036 4.65911 48.6576 4.28522 48.9655 3.97732C49.2954 3.64742 49.6913 3.48247 50.1531 3.48247C50.593 3.48247 50.9669 3.64742 51.2748 3.97732C51.6047 4.28522 51.7696 4.65911 51.7696 5.09897C51.7696 5.56082 51.6047 5.9567 51.2748 6.2866C50.9669 6.5945 50.593 6.74845 50.1531 6.74845C49.6913 6.74845 49.3064 6.5835 48.9985 6.25361C48.6686 5.9457 48.5036 5.56082 48.5036 5.09897ZM57.7505 21H55.1773V8.72783H57.7505V10.9381C58.1684 10.1904 58.7402 9.60756 59.4659 9.18969C60.2137 8.74983 61.0055 8.5299 61.8412 8.5299C63.2708 8.5299 64.4034 8.95876 65.2391 9.81649C66.0749 10.6742 66.4928 11.8948 66.4928 13.4784V21H63.8866V14.2701C63.8866 12.0048 62.9519 10.8722 61.0824 10.8722C60.1367 10.8722 59.345 11.1801 58.7072 11.7959C58.0694 12.3897 57.7505 13.2364 57.7505 14.3361V21ZM81.498 15.9856H71.865C71.931 16.8653 72.3378 17.5801 73.0856 18.1299C73.8334 18.6797 74.7021 18.9546 75.6918 18.9546C77.2533 18.9546 78.4189 18.4708 79.1887 17.5031L80.6732 19.1196C79.3536 20.5052 77.6272 21.1979 75.4938 21.1979C73.7344 21.1979 72.2609 20.6151 71.0732 19.4495C69.8856 18.2838 69.2918 16.7443 69.2918 14.8309C69.2918 12.9615 69.8966 11.444 71.1062 10.2783C72.3158 9.11271 73.7784 8.5299 75.4938 8.5299C77.2093 8.5299 78.6389 9.04674 79.7825 10.0804C80.9261 11.1141 81.498 12.4887 81.498 14.2041V15.9856ZM78.9248 13.9402C78.9248 12.9505 78.6059 12.1698 77.9681 11.5979C77.3523 11.0261 76.5495 10.7402 75.5598 10.7402C74.5701 10.7402 73.7014 11.0371 72.9536 11.6309C72.2279 12.2247 71.865 12.9945 71.865 13.9402H78.9248ZM86.938 15.7216V21H84.3648V8.72783H86.938V11.1691C87.3559 10.3993 87.9167 9.77251 88.6205 9.28866C89.3462 8.80481 90.105 8.55189 90.8967 8.5299L90.9297 11.1361H90.7978C89.5442 11.1361 88.5875 11.543 87.9277 12.3567C87.2679 13.1704 86.938 14.2921 86.938 15.7216Z" :fill="gradient ? '#0C819F' : fill" />
                <defs>
                    <linearGradient
                        :id="gradient ? 'paint0_linear_1691_8' : fill" x1="6.7366" y1="0" x2="6.7366"
                        y2="12.7167" gradientUnits="userSpaceOnUse"
                    >
                        <stop :stop-color="gradient ? '#0891B2' : fill" />
                        <stop offset="1" :stop-color="gradient ? '#0E7490' : fill" />
                    </linearGradient>
                    <linearGradient
                        :id="gradient ? 'paint1_linear_1691_8' : fill" x1="18.4134" y1="0" x2="18.4134"
                        y2="12.7167" gradientUnits="userSpaceOnUse"
                    >
                        <stop :stop-color="gradient ? '#0891B2' : fill" />
                        <stop offset="1" :stop-color="gradient ? '#0E7490' : fill" />
                    </linearGradient>
                    <linearGradient
                        :id="gradient ? 'paint2_linear_1691_8' : fill" x1="18.4134" y1="10.1733" x2="18.4134"
                        y2="22.89" gradientUnits="userSpaceOnUse"
                    >
                        <stop :stop-color="gradient ? '#0D7B99' : fill" />
                        <stop offset="0.336538" :stop-color="gradient ? '#0E7490' : fill" />
                    </linearGradient>
                    <linearGradient
                        :id="gradient ? 'paint3_linear_1691_8' : fill" x1="6.7366" y1="10.1733" x2="6.7366"
                        y2="22.89" gradientUnits="userSpaceOnUse"
                    >
                        <stop :stop-color="gradient ? '#0D7B99' : fill" />
                        <stop offset="0.336538" :stop-color="gradient ? '#0E7490' : fill" />
                    </linearGradient>
                </defs>
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    name: "NewAppLogoSVG",
    
    props: {
        position: {
            type: String,
            default: "center",
            validator: (value) => {
                return ["center", "left", "right"].includes(value);
            },
        },
        
        fill: {
            type: String,
            default: "#289CA9",
        },

        gradient: {
            type: Boolean,
            default: true,
        },

        textFill: {
            type: String,
            default: "#09383D",
        },

        width: {
            type: String,
            default: "16px",
        },

        height: {
            type: String,
            default: "",
        },
    },
};
</script>

<style lang="scss" scoped>
.logo {
    &__wrap {
        display: flex;
        cursor: pointer; 

        &.dashboard {
            margin-bottom: 1rem;
        }
        
        &.left {
            width: 100%;
            justify-content: flex-start;
        }

        &.center {
            width: fit-content;
            margin-left: auto;
            margin-right: auto;
            justify-content: center;
            padding: 10px 20px;  
        }
    }

    &__inner {
        img {
            width: 100%;
        }
    }
}
</style>